import { render, staticRenderFns } from "./timelineitem.vue?vue&type=template&id=28c462e8&"
import script from "./timelineitem.vue?vue&type=script&lang=js&"
export * from "./timelineitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports